import React, {
  useContext,
  useState,
  useRef,
  useEffect,
  Fragment,
} from "react";
import PropTypes from "prop-types";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import LocalStorageValues from "./LocalStorageValues";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Sort,
  Group,
} from "@syncfusion/ej2-react-grids";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import DvrIcon from "@mui/icons-material/Dvr";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PaidIcon from "@mui/icons-material/Paid";
import Tour from "./Tour";
import "./styles/DashboardAllProjects.css";

function DashboardAllProjects(props) {
  sessionStorage.removeItem("dashboardTaskList");
  sessionStorage.removeItem("dashboardAttachmentList");
  const TOUR_ID = "DashboardAllProjects";
  //const loadedSettings = JSON.parse(localStorage.getItem("oadaSettings"));
  const [dirty, isDirty] = useState(false);
  const loadedCreds = localStorage.getItem("instanceInfo");
  let parsedCreds;
  if (loadedCreds && loadedCreds.indexOf("company") == -1) {
    parsedCreds = JSON.parse(Tools.decrypt(loadedCreds));
  } else {
    parsedCreds = JSON.parse(loadedCreds);
  }
  const creds = useContext(CredsContext).creds || parsedCreds;
  const setCreds = useContext(CredsContext).setCreds;
  const lsv = new LocalStorageValues(creds, setCreds);
  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  const displayTable = useRef();
  const [favorites, setFavorites] = useState(false);
  const MONEY_COLUMN_WIDTH = 55;
  const HOURS_COLUMN_WIDTH = 48;
  const rawFavorites = localStorage.getItem(
    creds.company + "|FavoriteProjects",
  );

  const initialTourState = {
    //key: new Date(),
    run: false,
    loading: false,
    stepIndex: 0,
    steps: [
      {
        target: ".tour-stop-1",
        content: (
          <Box>
            <p>Welcome to Collab Center!</p>
            <p>This is the main project list view.</p>
            <p>
              Clicking on a project name in this column will open the Collab
              Center&apos;s tools for that project.
            </p>
          </Box>
        ),

        disableBeacon: true,
      },
      {
        target: ".tour-stop-2",
        content: (
          <Box>
            <p>These columns show the time-based metrics for each project.</p>
            <ul>
              <li>Budgeted hours for the project</li>
              <li>
                Actual project hours from all timesheets in SuiteProjects Pro
              </li>
              <li>Expected hours to complete the project (ETC)</li>
              <li>Expected hours upon project completion (EAC)</li>
              <li>Difference between budget hours and EAC (+/-)</li>
            </ul>
          </Box>
        ),
      },
    ],
  };
  //if (loadedSettings && loadedSettings.showFinancialsExternal) {
  initialTourState.steps.push({
    target: ".tour-stop-3",
    content: (
      <Box>
        <p>These columns show the financial metrics for each project.</p>
        <ul>
          <li>Budgete for the project</li>
          <li>Actual charges in SuiteProjects Pro</li>
          <li>Expected expense needed to complete the project (ETC)</li>
          <li>Expected expense upon project completion (EAC)</li>
          <li>Difference between budget and EAC (+/-)</li>
        </ul>
      </Box>
    ),
  });
  //}

  localStorage.removeItem("projectObject");
  sessionStorage.removeItem("dashboardConfig");
  sessionStorage.removeItem("dashboardItemList_risk");
  sessionStorage.removeItem("dashboardItemList_action");
  sessionStorage.removeItem("dashboardItemList_assumption");
  sessionStorage.removeItem("dashboardItemList_issue");
  sessionStorage.removeItem("dashboardItemList_decision");

  let grid;
  // let toolTip;

  lsv.initializeGlobalDefaults();
  /*
  const beforeRender = (args) => {
    if (args.target.classList.contains("e-rowcell")) {
      toolTip.content = args.target.innerText.substring(
        args.target.innerText.indexOf("\n") + 2,
      );
    }
  };

  let toolTipAnimation = {
    open: {  delay: 1000 },
    close: {  duration: 500, delay: 0 },
  };
*/
  let customerid = creds.client;

  const moneyConfig = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

  const numConfig = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
  });

  const handleProjectClick = async (event) => {
    props.waitHandler(true);
    const projmetrics = Tools.calculateProjectMetrics(event.data, creds);

    const loadingValues = await lsv.initializeProjectValues(event.data);
    // event.data is a project object ?

    // "props.onClick" calls the refreshDashboard function in the CollaborationCompanionToolbar component
    props.onClick(
      -1,
      event.data.id,
      event.data.name,
      event.data.oada_discussion__c,
      projmetrics,
      event.data,
    );
  };

  const customizeCell = (args) => {
    if (
      args.column.field === "moneyDiff" ||
      args.column.field === "hoursDiff"
    ) {
      if (parseFloat(args.data[args.column.field]) < 0) {
        args.cell.classList.add("projectsTableNumberCellNeg");
      } else {
        args.cell.classList.add("projectsTableNumberCellPos");
      }
    }
  };

  useEffect(() => {
    if (grid) {
      grid.getColumnByField("name").disableHtmlEncode = false;

      const headerCells = grid
        .getHeaderContent()
        .querySelectorAll(".e-headercell");
      headerCells.forEach((headerCell) => {
        headerCell.style.height = "30px";
        headerCell.style.background = "#154360";
      });
    }
  }, [grid]);

  const projectColumnHeaderTemplate = (info) => {
    return (
      <Stack direction="row" alignItems="center" gap={1}>
        <DvrIcon />
        <Typography
          className="tour-stop-1"
          sx={{
            color: "black",
            fontWeight: "bold",
            fontSize: "large",
          }}
        >
          {info.headerText}
        </Typography>
      </Stack>
    );
  };

  const columnHeaderTemplate = (info) => {
    const columnIndex = parseInt(info.index);
    let bgColor = "white !important";
    if (columnIndex % 2 == 1) {
      bgColor = "beige !important";
    }
    return (
      <div>
        <Typography
          sx={{
            color: "black",
            fontWeight: "bold",
            fontSize: "14px !important",
          }}
        >
          {info.headerText}
        </Typography>
      </div>
    );
  };

  const groupHeaderTemplate = (info) => {
    return (
      <Stack direction="row" alignItems="center" gap={1}>
        {info.headerText == "Hours" ? (
          <Box>
            <ScheduleIcon />
            <Typography
              className="tour-stop-2"
              sx={{ color: "black", fontWeight: "bold", fontSize: "large" }}
            >
              {info.headerText}
            </Typography>
          </Box>
        ) : (
          <Box>
            <PaidIcon />
            <Typography
              className="tour-stop-3"
              sx={{ color: "black", fontWeight: "bold", fontSize: "large" }}
            >
              {info.headerText}
            </Typography>
          </Box>
        )}
      </Stack>
    );
  };

  const handleProjectListChange = () => {
    setFavorites(!favorites);
    console.log("here");
  };

  const moneyBudgetTemplate = (projectProps) => {
    return (
      <div>
        {projectProps.oada_project_show_billing__c == 1
          ? moneyConfig.format(parseInt(projectProps.budget))
          : "-"}
      </div>
    );
  };

  const moneyActualTemplate = (projectProps) => {
    return (
      <div>
        {projectProps.oada_project_show_billing__c == 1
          ? moneyConfig.format(parseInt(projectProps.oada_actual_money__c))
          : "-"}
      </div>
    );
  };

  const moneyETCTemplate = (projectProps) => {
    return (
      <div>
        {projectProps.oada_project_show_billing__c == 1
          ? moneyConfig.format(parseInt(projectProps.oada_etc_money__c))
          : "-"}
      </div>
    );
  };

  const moneyEACTemplate = (projectProps) => {
    return (
      <div>
        {projectProps.oada_project_show_billing__c == 1
          ? moneyConfig.format(parseInt(projectProps.oada_eac_money__c))
          : "-"}
      </div>
    );
  };

  const moneyDiffTemplate = (projectProps) => {
    return (
      <div>
        {projectProps.oada_project_show_billing__c == 1
          ? moneyConfig.format(parseInt(projectProps.moneyDiff))
          : "-"}
      </div>
    );
  };

  useEffect(() => {
    const moneyFields = [
      "budget",
      "oada_actual_money__c",
      "oada_eac_money__c",
      "oada_etc_money__c",
    ];
    let requestString;
    if (creds.userType == "generic") {
      requestString = authString;
      requestString +=
        '<Read type="Project" method="equal to" limit="1000" enable_custom="1" order="name"><Project><customerid>' +
        customerid +
        "</customerid></Project></Read></request>";
    } else {
      if (rawFavorites && rawFavorites != "[]") {
        requestString = authString;
        const favoritesArray = JSON.parse(rawFavorites);
        favoritesArray.forEach((favoriteRecord) => {
          requestString +=
            '<Read type="Project" method="equal to" limit="1000" enable_custom="1" order="name"><Project><id>' +
            favoriteRecord.projectId +
            "</id></Project></Read>";
        });
        requestString += "</request>";
      }
    }
    if (requestString) {
      //props.waitHandler(true);
      lsv.findNewProjects();
      Tools.fetchPost(requestString, urlString, "Project").then(
        (projectRecord) => {
          let projArray = [];
          for (let i = 0; i < projectRecord.xml.length; i++) {
            let projObject = {};
            for (const entry of projectRecord.xml[i].childNodes.entries()) {
              const fieldName = entry[1].nodeName;
              const node = projectRecord.xml[i].childNodes[entry[0]];

              // Check if this is a Date node with nested year/month/day structure
              let fieldValue;
              if (
                node.childNodes.length > 0 &&
                node.querySelector("year, month, day")
              ) {
                // Parse nested date structure to MMddyyyy format
                const year = node.querySelector("year")?.textContent || "";
                const month = node.querySelector("month")?.textContent || "";
                const day = node.querySelector("day")?.textContent || "";

                if (year && month && day) {
                  // Format as MMddyyyy (pad month and day with leading zeros if needed)
                  fieldValue =
                    month.padStart(2, "0") + day.padStart(2, "0") + year;
                } else {
                  fieldValue = node.textContent;
                }
              } else {
                fieldValue = node.textContent;
              }

              if (moneyFields.indexOf(fieldName) != -1) {
                const origFieldName = fieldName + "_orig";
                projObject = { ...projObject, [origFieldName]: fieldValue };
                // have to convert text to float for the format function in the grid to work
                fieldValue = parseFloat(fieldValue);
              }

              projObject = { ...projObject, [fieldName]: fieldValue };
            }
            if (projObject && projObject.oada_bill_type__c != "FF") {
              const projmetrics = Tools.calculateProjectMetrics(
                projObject,
                creds,
              );
              projObject.oada_etc_hours__c = projmetrics.estimateToCompletion;
              projObject.oada_eac_hours__c = projmetrics.estimateAtCompletion;
              projArray.push(projObject);
            }
          }

          let showBilling = false;
          for (let j = 0; j < projArray.length; j++) {
            if (projArray[j].oada_project_show_billing__c == "1") {
              showBilling = true;
            }
            projArray[j].hoursDiff = numConfig.format(
              parseInt(
                parseInt(projArray[j].budget_time) -
                  parseInt(projArray[j].oada_eac_hours__c),
              ),
            );

            projArray[j].moneyDiff =
              parseInt(projArray[j].budget_orig) -
              parseInt(projArray[j].oada_eac_money__c_orig);

            if (projArray[j].oada_project_health__c !== "") {
              projArray[j].displayName =
                projArray[j].name +
                " [[" +
                projArray[j].oada_project_health__c +
                "]]";
            } else {
              projArray[j].displayName = projArray[j].name;
            }
          }

          const moneyColumns = [
            {
              field: "budget",
              format: "C0",
              headerText: "Budget",
              textAlign: "Right",
              width: MONEY_COLUMN_WIDTH,
              headerTemplate: columnHeaderTemplate,
              template: moneyBudgetTemplate,
              customAttributes: { class: "projectsTableMoneyCell" },
            },
            {
              field: "oada_actual_money__c",
              format: "C0",
              headerText: "Actual",
              width: MONEY_COLUMN_WIDTH,
              textAlign: "Right",
              headerTemplate: columnHeaderTemplate,
              template: moneyActualTemplate,
              customAttributes: { class: "projectsTableMoneyCell" },
            },
            {
              field: "oada_etc_money__c",
              format: "C0",
              headerText: "ETC",
              width: MONEY_COLUMN_WIDTH,
              textAlign: "Right",
              headerTemplate: columnHeaderTemplate,
              template: moneyETCTemplate,
              customAttributes: { class: "projectsTableMoneyCell" },
            },
            {
              field: "oada_eac_money__c",
              format: "C0",
              headerText: "EAC",
              width: MONEY_COLUMN_WIDTH,
              textAlign: "Right",
              headerTemplate: columnHeaderTemplate,
              template: moneyEACTemplate,
              customAttributes: { class: "projectsTableMoneyCell" },
            },
            {
              field: "moneyDiff",
              format: "C0",
              headerText: "+/-",
              width: MONEY_COLUMN_WIDTH,
              textAlign: "Right",
              headerTemplate: columnHeaderTemplate,
              template: moneyDiffTemplate,
              customAttributes: { class: "projectsTableMoneyCell" },
            },
          ];

          const hoursColumns = [
            {
              field: "budget_time",
              headerText: "Budget",
              textAlign: "Right",
              width: HOURS_COLUMN_WIDTH,
              headerTemplate: columnHeaderTemplate,
              customAttributes: { class: "projectsTableHoursCell" },
            },
            {
              field: "oada_actual_hours__c",
              headerText: "Actual",
              width: HOURS_COLUMN_WIDTH,
              textAlign: "Right",
              headerTemplate: columnHeaderTemplate,
              customAttributes: { class: "projectsTableHoursCell" },
            },
            {
              field: "oada_etc_hours__c",
              headerText: "ETC",
              width: HOURS_COLUMN_WIDTH,
              textAlign: "Right",
              headerTemplate: columnHeaderTemplate,
              customAttributes: { class: "projectsTableHoursCell" },
            },
            {
              field: "oada_eac_hours__c",
              headerText: "EAC",
              width: HOURS_COLUMN_WIDTH,
              textAlign: "Right",
              headerTemplate: columnHeaderTemplate,
              customAttributes: { class: "projectsTableHoursCell" },
            },
            {
              field: "hoursDiff",
              headerText: "+/-",
              width: HOURS_COLUMN_WIDTH,
              textAlign: "Right",
              headerTemplate: columnHeaderTemplate,
              customAttributes: { class: "projectsTableHoursCell" },
            },
          ];

          const nameColumnTemplate = (obj) => {
            let chipColor = "silver";
            let chipTextColor = "white";
            if (obj.oada_project_health__c == "Green") {
              chipColor = "green";
            } else if (obj.oada_project_health__c == "Yellow") {
              chipColor = "gold";
              chipTextColor = "black";
            } else if (obj.oada_project_health__c == "Red") {
              chipColor = "crimson";
            }

            const healthIndex = obj.displayName.indexOf("[[");
            //let displayNameObject = <span>{obj.displayName}</span>;
            let newDisplayName = obj.displayName;
            if (healthIndex != -1) {
              newDisplayName = obj.displayName.substring(0, healthIndex);
            }
            let displayNameObject = (
              <>
                <Chip
                  size="small"
                  label={
                    healthIndex != -1 ? obj.oada_project_health__c : "Status?"
                  }
                  sx={{
                    backgroundColor: [chipColor],
                    color: [chipTextColor],
                    width: "70px",
                  }}
                />
                <span>&nbsp;&nbsp;{newDisplayName}</span>
              </>
            );
            //}
            return displayNameObject;
          };

          const groupOptions = {
            columns: ["customer_name"],
            showDropArea: false,
            captionTemplate:
              '<span style="color:white;background-color:#643f69;border-radius:10px;padding-left:6px;padding-right:6px;padding-top:2px;padding-bottom:2px">${key}</span>',
          };

          displayTable.current = (
            <Fragment>
              <Tour initialState={initialTourState} width={500} id={TOUR_ID} />
              <Box sx={{ border: "solid 2px" }}>
                <GridComponent
                  dataSource={projArray}
                  ref={(g) => (grid = g)}
                  rowSelected={handleProjectClick}
                  queryCellInfo={customizeCell}
                  allowSorting={true}
                  allowGrouping={creds.userType == "generic" ? false : true}
                  groupSettings={groupOptions}
                  enableStickyHeader={true}
                  cssClass="dashAllProjectsGrid"
                >
                  <Inject services={[Sort, Group]} />
                  <ColumnsDirective>
                    <ColumnDirective
                      field="displayName"
                      headerText="Project"
                      headerTemplate={projectColumnHeaderTemplate}
                      width="150"
                      textAlign="Left"
                      template={nameColumnTemplate}
                      customAttributes={{ class: "projectsTableNameCell" }}
                      allowSorting={true}
                    />
                    <ColumnDirective
                      field="customer_name"
                      headerText="Customer"
                      //headerTemplate={projectHeaderTemplate}
                      width="150"
                      textAlign="Left"
                      //template={nameColumnTemplate}
                      customAttributes={{ class: "projectsTableNameCell" }}
                      visible={creds.userType != "generic"}
                    />
                    <ColumnDirective
                      headerText="Hours"
                      columns={hoursColumns}
                      textAlign="Center"
                      headerTemplate={groupHeaderTemplate}
                      customAttributes={{ class: "hours" }}
                    />
                    {showBilling ? (
                      <ColumnDirective
                        headerText="Financials"
                        columns={moneyColumns}
                        textAlign="Center"
                        headerTemplate={groupHeaderTemplate}
                        customAttributes={{ class: "money" }}
                      />
                    ) : null}
                  </ColumnsDirective>
                </GridComponent>
              </Box>
            </Fragment>
          );
          isDirty(!dirty);
          props.waitHandler(false);
        },
      );
    }
  }, []);

  return <Fragment>{displayTable.current}</Fragment>;
}

export default DashboardAllProjects;

DashboardAllProjects.propTypes = {
  onClick: PropTypes.func,
  waitHandler: PropTypes.func,
};
